import { useUpdateTask } from 'features/tasks';
import React from 'react';
import { Plus } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { useToday } from 'shared/contexts/today';
import { Task } from 'shared/types/task';
import { Timestamp } from 'shared/types/timestamp';
import { createPlannedOccurrenceForDate } from 'shared/utils/schedules';
import { getScheduleByDate } from 'shared/utils/schedules/get-schedule-by-date';

import { useData } from '../../use-data';
import * as Styled from './upcoming-slot.style';
import { useSlotData } from './use-slot-data';

export type AddSlotProps = {
  task: Task;
  date: Timestamp;
};

export const AddSlot: React.FC<AddSlotProps> = ({ task, date }) => {
  const today = useToday();
  const { weekStartsOn } = useData();
  const { submit: updateTask } = useUpdateTask();

  const { label, isToday } = useSlotData({ task, date });

  const onAdd = () => {
    if (!task.schedules?.length) {
      return;
    }

    const scheduleForDate = getScheduleByDate(task.schedules, { date, today });
    const schedules = createPlannedOccurrenceForDate(task.schedules, date, {
      timeslot: scheduleForDate?.timeslot,
      today,
      weekStartsOn,
    });

    updateTask({ id: task.id, schedules });
  };

  return (
    <Styled.Container onClick={onAdd}>
      <Styled.StartIconContainer>
        <Icon icon={Plus} />
      </Styled.StartIconContainer>
      <Styled.LabelContainer $isToday={isToday}>
        <Styled.LabelWrapper>
          <Styled.LabelText>{label}</Styled.LabelText>
        </Styled.LabelWrapper>
      </Styled.LabelContainer>
    </Styled.Container>
  );
};
